import ApiBase from '@/services/ApiBase';
import { API_URL, getApiUrl } from '@/utils/api';
import { PlaceSuggestion } from '@/models/GooglePlaces.model';

interface AutocompleteResponse {
  suggestions: PlaceSuggestion[];
}

interface PlaceDetails {
  street: string;
  postalCode: string;
  city: string;
  state?: string;
  country: string;
}

export default class GooglePlacesService extends ApiBase {
  static placesUrl = getApiUrl(API_URL.USER, '/places');

  async autocomplete(input: string, sessionToken: string): Promise<PlaceSuggestion[]> {
    const params = new URLSearchParams({
      input: input,
      sessionToken: sessionToken,
      navigatorLanguage: navigator.language
    });

    const url = `${GooglePlacesService.placesUrl}/autocomplete?${params.toString()}`;

    const data: AutocompleteResponse = await this.api.postPromisedJSON(url, {});

    return data.suggestions;
  }

  async getPlaceDetails(placeId: string, sessionToken: string): Promise<PlaceDetails> {
    return await this.api.getPromisedJSON(`${GooglePlacesService.placesUrl}/details/${placeId}?sessionToken=${sessionToken}`);
  }
}
